import React from 'react';
import jumuahImg from '../assets/images/misc/jumuah.jpg';
import imaamImg from '../assets/images/misc/imaam.jpg';
import learningImg from '../assets/images/misc/learning.jpg';

const goals = [
  { number: '1', title: 'Strong Community Support', icon: 'bi-people-fill', description: 'Building bonds among members and a welcoming space for Bothasig and beyond.', image: jumuahImg, alt: 'Jumuah' },
  { number: '2', title: 'Young Dynamic Imaamat', icon: 'bi-person-badge-fill', description: 'Inspiring leadership and spiritual guidance for our growing community.', image: imaamImg, alt: 'Imaam' },
  { number: '3', title: 'Engaging Learning Opportunities', icon: 'bi-book-half', description: 'Madrasah, adult classes, and programs that empower faith and life skills.', image: learningImg, alt: 'Learning' },
];

const OurTargetSection: React.FC = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="our-target" className="our-target-section">
      <div className="container py-4 py-md-5 px-3 px-md-0">
        <div className="row justify-content-center mb-4">
          <div className="col-lg-10 text-center">
            <span className="section-eyebrow">Our Target</span>
            <h2 className="section-title mt-2 mb-4">Three pillars we work towards</h2>
          </div>
        </div>
        <div className="row g-4 mb-5">
          {goals.map((goal, index) => (
            <div key={goal.number} className="col-12 col-md-6 col-lg-4">
              <div className="target-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="target-card-image-wrap">
                  <img src={goal.image} alt={goal.alt} className="target-card-image" />
                  <span className="target-card-number">{goal.number}</span>
                </div>
                <div className="target-card-body">
                  <div className="target-card-icon">
                    <i className={`bi ${goal.icon}`}></i>
                  </div>
                  <h3 className="target-card-title">{goal.title}</h3>
                  <p className="target-card-desc text-muted mb-0">{goal.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center">
          <button type="button" className="btn btn-primary btn-lg px-4 py-3 rounded-pill shadow-lg btn-glow" onClick={scrollToContact}>
            <i className="bi bi-heart-fill me-2"></i>Get in Touch
          </button>
        </div>
      </div>
    </section>
  );
};

export default OurTargetSection;
